import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "notranslate" }
const _hoisted_2 = { class: "pr-1" }
const _hoisted_3 = { class: "text-xs flex justify-between" }
const _hoisted_4 = { class: "mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_judge_badge = _resolveComponent("judge-badge")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.judgeQueue, (judge) => {
      return (_openBlock(), _createElementBlock("li", {
        key: judge.judgeId,
        class: "text-sm border p-1 pl-3 border-primary-50 dark:border-dark-200"
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(judge.problemId) + ":", 1),
          _createTextVNode(" " + _toDisplayString(judge.userId), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_judge_badge, {
            status: judge.status
          }, null, 8, ["status"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.timestampToDate(judge.submissionDate)), 1)
        ])
      ]))
    }), 128))
  ]))
}